import { useState } from 'react';

const NAV = [
  { key: 'deep', label: '图文深扒', href: '#deep-read' },
  { key: 'diagram', label: '帖子图解', href: '#diagram' },
  { key: 'long', label: '长文连载', href: '#long-read' },
  { key: 'collection', label: '合集索引', href: '#collections' },
  { key: 'talk', label: '讨论版', href: '#discussion' }
];

const LIVE = ['某MCN账号前员工再爆料', '直播间控评时间线新增三条', '旧聊天记录截图补档完成'];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40">
      {/* 顶栏：实时运营信息 */}
      <div className="bg-ink text-paper2">
        <div className="mx-auto flex h-9 max-w-[1360px] items-center justify-between px-4 text-xs md:px-6">
          <div className="flex min-w-0 items-center gap-2">
            <span className="relative flex h-2 w-2 shrink-0 items-center justify-center">
              <span className="absolute h-2 w-2 animate-ping rounded-full bg-verm/70" />
              <span className="relative h-2 w-2 rounded-full bg-verm" />
            </span>
            <span className="hidden whitespace-nowrap font-medium sm:block">今日已更新</span>
            <span className="whitespace-nowrap font-semibold text-gold-soft">38 帖 · 24 图解</span>
          </div>
          <div className="hidden min-w-0 flex-1 items-center gap-6 overflow-hidden px-6 lg:flex">
            {LIVE.map((t, i) => (
              <span key={i} className="flex items-center gap-1.5 truncate">
                <i className="ri-live-line text-verm" />
                <span className="truncate text-paper2/70">{t}</span>
              </span>
            ))}
          </div>
          <div className="flex shrink-0 items-center gap-3">
            <span className="text-paper2/50">2026.09.09</span>
            <span className="hidden text-paper2/30 sm:block">|</span>
            <a href="#discussion" className="hidden whitespace-nowrap hover:text-gold-soft sm:block">我有线索</a>
            <a href="#deep-read" className="hidden whitespace-nowrap font-semibold text-gold-soft hover:opacity-80 sm:block">投稿深扒</a>
          </div>
        </div>
      </div>

      {/* 主栏：报头 + 导航 */}
      <div className="border-b border-line bg-paper/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1360px] items-center justify-between gap-4 px-4 py-3 md:px-6">
          <a href="#top" className="group flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center bg-verm text-paper2 md:h-10 md:w-10">
              <i className="ri-shield-flash-line text-xl" />
            </span>
            <span className="leading-none">
              <span className="font-display block text-lg font-black tracking-wide text-verm md:text-2xl">最全黑料</span>
              <span className="mt-1 hidden text-[11px] tracking-widest text-ink/45 md:block">图文 · 图解 · 长文 全细节深扒</span>
            </span>
          </a>

          <nav className="hidden items-center gap-7 lg:flex">
            {NAV.map((n) => (
              <a
                key={n.key}
                href={n.href}
                className="group relative whitespace-nowrap text-[15px] font-medium text-ink/80 hover:text-verm"
              >
                {n.label}
                <span className="absolute -bottom-1.5 left-0 h-0.5 w-0 bg-verm transition-all group-hover:w-full" />
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <form
              className="hidden items-center gap-2 border border-line bg-paper2 px-3 py-2 focus-within:border-verm/50 lg:flex"
              onSubmit={(e) => e.preventDefault()}
            >
              <i className="ri-search-line text-ink/45" />
              <input
                type="text"
                placeholder="搜关键词 / 人物 / 事件"
                className="w-40 bg-transparent text-sm outline-none placeholder:text-ink/35"
              />
              <button type="submit" aria-label="搜索" className="whitespace-nowrap text-verm">
                搜索
              </button>
            </form>
            <a href="#discussion" className="whitespace-nowrap border border-verm bg-paper2 px-4 py-2 text-sm font-semibold text-verm hover:bg-verm-soft">
              登录
            </a>
            <button
              type="button"
              aria-label="发帖"
              className="whitespace-nowrap bg-verm px-4 py-2 text-sm font-semibold text-paper2 hover:bg-verm-dark"
            >
              + 发帖深扒
            </button>
          </div>

          {/* 移动端汉堡 */}
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center border border-line bg-paper2 lg:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
          </button>
        </div>

        {/* 移动端菜单面板 */}
        {open && (
          <div className="border-t border-line bg-paper2 px-4 py-3 lg:hidden">
            <div className="flex flex-col gap-2">
              {NAV.map((n) => (
                <a
                  key={n.key}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between border-b border-line/60 py-2.5 text-sm font-medium hover:text-verm"
                >
                  {n.label}
                  <i className="ri-arrow-right-s-line" />
                </a>
              ))}
              <a href="#discussion" className="whitespace-nowrap bg-verm px-4 py-2.5 text-center text-sm font-semibold text-paper2">
                + 发帖深扒
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}